/* SIGN UP FORM VALIDATION SCIPT */
(function klaviyoSignUpFormEmailValidation() {
  let isBound = false;

  function addValidation() {
    if (isBound) return;

    console.log("🔍 Looking for Klaviyo form to apply validation...");

    // FIND FORM, INPUT AND BUTTON, ALSO CHECK THAT THE window.klaviyo OBJECT EXISTS
    const form = document.querySelector("form.klaviyo-form");
    if (!form) return;
    if (!window.klaviyo) return;

    const formField = form.querySelector('input[id^="email_"]');
    const submitBtn = form.querySelector(
      "button[data-action-id]:not(.klaviyo-close-form)",
    );

    // IF NOT FOUND, RETURN
    if (!formField || !submitBtn) return;

    const originalButtonText = submitBtn.innerText || "Submit";
    const invalidClass = "klaviyo-email-invalid";
    const invalidStyleId = "klaviyo-email-invalid-style";

    function setInputStyles() {
      if (document.getElementById(invalidStyleId)) return;

      const styleEl = document.createElement("style");
      styleEl.id = invalidStyleId;
      styleEl.textContent = `
        form.klaviyo-form input[id^="email_"] {
          outline: none !important;
          border: 1px solid #000;
          border-color: #000 !important;
        }
        form.klaviyo-form input.${invalidClass},  
        form.klaviyo-form input[id^="email_"].${invalidClass},
        form.klaviyo-form input[id^="email_"].${invalidClass}:focus,
        form.klaviyo-form input[id^="email_"].${invalidClass}:active,
        form.klaviyo-form input[id^="email_"].${invalidClass}:focus-visible {
          border: 1px solid #ff4d4d !important;
        }
      `;

      document.head.appendChild(styleEl);
    }

    function validateEmail(email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    }

    // CLEAR ERROR STYLE ON INPUT
    formField.addEventListener("input", () => {
      formField.classList.remove(invalidClass);
    });

    // VALIDATE BEFORE SUBMIT
    submitBtn.addEventListener(
      "click",
      (e) => {
        const emailValue = formField.value.trim();

        if (!validateEmail(emailValue)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          setTimeout(() => {
            submitBtn.removeAttribute("disabled");
            submitBtn.classList.remove("klaviyo-spinner");
            if (submitBtn.innerText === "") {
              submitBtn.innerText = originalButtonText;
            }
          }, 0);

          // ADD ERROR STYLE CLASS AND FOCUS THE FIELD
          formField.classList.add(invalidClass);
          formField.focus();
        } else {
          formField.style = "";
          formField.classList.remove(invalidClass);
        }
      },
      { capture: true },
    );

    setInputStyles();

    isBound = true;
    observer.disconnect();
  }

  // OBSERVE THE BODY ELEMENT FOR CHANGES
  const observer = new MutationObserver(addValidation);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  addValidation();
})();
